import React from 'react';

export default function Cabecalho({ boletimVistoria }) {

    return (
        <>
            <h5 className="subtitleCardInfo">Cabeçalho</h5>
            <div className="row align-items-end">
                {boletimVistoria.boletimVistoriaCabecalhos.map((m, key) => (
                    <div className="col-6 col-lg-4 col-md-6 col-sm-12" key={key}>
                        <div className="form-group">
                            <span>{m.formularioVistoriaCabecalho_Identificacao}</span>
                            <input className="form-control"
                                autocomplete="off"
                                type="text"
                                value={m.valor}
                                disabled={true}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}
